import React from 'react'
import { getClassNames } from '../../_utils/classnames'
import { ColorPicker } from 'antd'
import { DEFAULT_COLOR_PRESETS } from '@pushly/aqe/lib/components/color-swatch-field/color-swatch-field'
import type { Color as AntColor } from 'antd/es/color-picker'

import './color-picker-popover.scss'

type Color = string | null | undefined

interface IColorPickerPopoverProps {
    className?: string
    defaultColor?: Color
    color: Color
    onChange: (color: Color) => void
    content?: React.ReactNode
    disabled?: boolean
    /**
     * @deprecated The picker now always offers presets plus the full spectrum,
     * so there is no longer a simple/advanced distinction to select.
     */
    picker?: 'sketch' | 'compact'
}

const ColorPickerPopover = (props: IColorPickerPopoverProps) => {
    const handleChange = (value: AntColor) => {
        const hex = value?.toHexString()?.trim()
        props.onChange(!!hex ? hex.toUpperCase() : null)
    }

    return (
        <ColorPicker
            rootClassName={getClassNames(null, props.className, 'color-picker-popover-trigger')}
            classNames={{ popup: { root: getClassNames(null, 'color-picker-popover') } }}
            value={props.color ?? '#FFFFFF'}
            presets={DEFAULT_COLOR_PRESETS}
            disabledAlpha={true}
            disabled={props.disabled}
            showText={false}
            onChangeComplete={handleChange}
        >
            {/* Callers pass tooltip-wrapped buttons, which do not forward a DOM
                ref, leaving the panel with nothing to anchor to. A plain span
                always gives it one. */}
            <span className="color-picker-trigger">
                {props.content ?? (
                    <span className="color-picker-popover-preview">
                        <span
                            className="color-preview-swatch"
                            style={{ backgroundColor: !props.color ? '#FFF' : props.color }}
                        />
                        <span className="color-code">{props.color ?? 'N/A'}</span>
                    </span>
                )}
            </span>
        </ColorPicker>
    )
}

export default ColorPickerPopover
